const PRE = 'DINAMIC_CUSTOM_FORM_';

export const SALVAR_OBJ = PRE + 'SALVAR_OBJ';
export const LISTAR_OBJ = PRE + 'LISTAR_OBJ';

export const LISTAR = PRE + 'LISTAR';
export const CARREGAR_FORM = PRE + 'CARREGAR_FORM';





// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/actionTypes.js